var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.uri)?_c('iframe',{staticClass:"map map__frame",style:(_vm.height ? ("height: " + _vm.height + ";") : ''),attrs:{"allow":"local-network-access","src":_vm.uri}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }